import spinnerSvg from './spinner.png';

export default function SpinnerCircle({ size }: { size: number }) {
  return (
    <div
      role="progressbar"
      aria-label="Loading…"
      style={{
        width: size,
        height: size,
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          backgroundSize: 'cover',
          backgroundImage: `url(${JSON.stringify(spinnerSvg)})`,
          animation: 'spinner-rotate 0.6s linear infinite',
        }}
      />
    </div>
  );
}
